import React from 'react';

import SubscriptionPage from './index';

const PriceCompare = () => <SubscriptionPage useTopLevelLocation />;

export default PriceCompare;
